module.exports = __webpack_public_path__ + "img/01-price-title2.ba345654.png";